var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Help",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2852",
    "data-name": "Rectangle 2852",
    width: 16,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13254",
    "data-name": "Group 13254",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13104",
    "data-name": "Path 13104",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0M8,14.474A6.474,6.474,0,1,1,14.474,8,6.473,6.473,0,0,1,8,14.474",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13105",
    "data-name": "Path 13105",
    d: "M10.441,4a2.935,2.935,0,0,0-2.1-.805c-.076,0-.152.007-.227.015l-.029,0H8.083A3.906,3.906,0,0,0,5.114,4.561a.761.761,0,0,0-.24.538.715.715,0,0,0,.732.71.8.8,0,0,0,.538-.232,2.615,2.615,0,0,1,2-.914A1.488,1.488,0,0,1,9.777,6c0,.04.006.078.007.137,0,1.237-1.277,1.519-2.029,1.575a.65.65,0,0,0-.453.208.662.662,0,0,0-.168.5l0,1.4a.744.744,0,0,0,.742.675h.085a.746.746,0,0,0,.676-.749V8.933a2.875,2.875,0,0,0,2.715-2.885A2.917,2.917,0,0,0,10.441,4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13106",
    "data-name": "Path 13106",
    d: "M7.89,11.225a.875.875,0,1,0,.875.875.877.877,0,0,0-.875-.875",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.43c29535b4fccaf2fde5fcbfc22e3445.svg";
export { ForwardRef as ReactComponent };